module.exports = __webpack_public_path__ + "img/home.35cc01d7.png";